import { Pipe, PipeTransform } from '@angular/core';

import { IconsEnum } from '@enums/icons.enum';

import { isRegisteredDsIcon } from '@design-system/ds-icon/helpers/is-registered-ds-icon.helper';

@Pipe({
  name: 'dsIsRegisteredIcon',
  standalone: true,
})
export class DsIsRegisteredIconPipe implements PipeTransform {
  /**
   * Returns true when the icon name is a registered SVG (`IconsEnum`) value.
   *
   * @param name - Material ligature name or `IconsEnum` value
   * @returns true when `ds-icon` should render an SVG instead of a font icon
   */
  transform(name: string | IconsEnum | null | undefined): boolean {
    return isRegisteredDsIcon(name);
  }
}
